export default __webpack_public_path__ + "static/media/2.47ced0a1.png";